import { AVAILABLE_LOCALES, detectLocale, localeInfo, useT } from '@/i18n';
import { settingsStore, useSettings } from '@/settings/settingsStore';
import type { Locale } from '@/types';

const AUTO = 'auto';

/** Language picker: "follow the browser" plus every locale that has a catalog. */
export function LanguageSelect({ className }: { className?: string }) {
  const { t } = useT();
  const settings = useSettings();
  return (
    <label className={`lang ${className ?? ''}`}>
      <span className="muted">{t('settings.language')}</span>
      <select value={settings.locale ?? AUTO} aria-label={t('settings.language')} onChange={(e) => settingsStore.setLocale(e.target.value === AUTO ? undefined : (e.target.value as Locale))}>
        <option value={AUTO}>{t('settings.languageAuto', { detected: localeInfo(detectLocale()).label })}</option>
        {AVAILABLE_LOCALES.map((l) => (
          <option key={l} value={l}>{localeInfo(l).label}</option>
        ))}
      </select>
    </label>
  );
}
